import { cn } from "@/lib/utils";

import { type AggregatorListItem, type MetricTone } from "./types";

export const DEFAULT_PAGE_SIZE = 20;
export const ACTION_BUTTON_CLASS = "min-w-20";

// Caps numeric columns so the table stays compact and the flexible name column absorbs
// the remaining horizontal space. Wide enough to fit the longest single-word header next
// to its sort icon, while multi-word headers still wrap onto two lines.
export const NUMBER_COLUMN_WIDTH_CLASS = "max-w-32";

export const AGGREGATOR_SORT_OPTIONS = [
  { id: "name", translationKey: "aggregators.list.columns.name" },
  { id: "area", translationKey: "aggregators.list.columns.area" },
  { id: "lastActive", translationKey: "aggregators.list.columns.lastActive" },
  { id: "farmers", translationKey: "aggregators.list.columns.farmers" },
  { id: "farmersTarget", translationKey: "aggregators.list.columns.farmersTarget" },
  { id: "eventsCreated", translationKey: "aggregators.list.columns.eventsCreated" },
  { id: "harvestsCreated", translationKey: "aggregators.list.columns.harvestsCreated" },
  { id: "deposits", translationKey: "aggregators.list.columns.deposits" },
  { id: "offersReceived", translationKey: "aggregators.list.columns.offersReceived" },
  { id: "offersAccepted", translationKey: "aggregators.list.columns.offersAccepted" },
  { id: "exchanges", translationKey: "aggregators.list.columns.exchanges" },
  { id: "farmerPayments", translationKey: "aggregators.list.columns.farmerPayments" },
] as const;

export const COMPACT_HEADER_CLASS = "px-3 py-2 !whitespace-normal leading-tight";
export const NUMERIC_HEADER_CLASS = cn(COMPACT_HEADER_CLASS, "text-center");
export const SEARCHABLE_AGGREGATOR_FIELDS = [
  "name",
  "area",
] as const satisfies readonly (keyof AggregatorListItem)[];

// Maps the backend `last_active_source` codes to i18n keys so the Last active column
// can label which activity produced the most recent timestamp.
export const LAST_ACTIVE_SOURCE_TRANSLATION_KEYS: Record<string, string> = {
  farmer: "aggregators.list.lastActiveSource.farmer",
  deposit: "aggregators.list.lastActiveSource.deposit",
  market_offer: "aggregators.list.lastActiveSource.marketOffer",
  farmer_payment: "aggregators.list.lastActiveSource.farmerPayment",
  exchange: "aggregators.list.lastActiveSource.exchange",
  commodity_event: "aggregators.list.lastActiveSource.commodityEvent",
  harvest: "aggregators.list.lastActiveSource.harvest",
  agro_advisory_read: "aggregators.list.lastActiveSource.agroAdvisoryRead",
  farmer_training_event: "aggregators.list.lastActiveSource.farmerTrainingEvent",
  input_distribution_event: "aggregators.list.lastActiveSource.inputDistributionEvent",
  equipment_distribution_event: "aggregators.list.lastActiveSource.equipmentDistributionEvent",
};

export const METRIC_TONE_CLASS: Record<MetricTone, string> = {
  default: "text-foreground",
  warning: "text-warning-700",
  primary: "text-primary-600",
};
